export default __webpack_public_path__ + "static/media/greenpizza@2x.dd18704c.jpg";